import { render, staticRenderFns } from "./ComplianceBlock.vue?vue&type=template&id=00efd4cc&scoped=true&lang=pug"
import script from "./ComplianceBlock.vue?vue&type=script&lang=ts"
export * from "./ComplianceBlock.vue?vue&type=script&lang=ts"
import style0 from "./ComplianceBlock.vue?vue&type=style&index=0&id=00efd4cc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00efd4cc",
  null
  
)

export default component.exports